import React from "react";

import {
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Add as AddIcon } from "@mui/icons-material";
import AppcodeForm from "./AppcodeForm";
// ----------------------------------------------------------------------
export default function AppcodeEditBtn({ editData }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const getTitle = () => {
    try {
      if (editData && editData.id) {
        return `Modification`;
      } else {
        return "Nouveau code d'application";
      }
    } catch (error) {
      return "";
    }
  };
  const getIcon = () => {
    try {
      if (editData && editData.id) {
        return (
          <IconButton
            aria-label="details"
            size="small"
            onClick={handleClickOpen}
          >
            <EditIcon />
          </IconButton>
        );
      } else {
        return (
          <Button variant="contained" color="primary" onClick={handleClickOpen}>
            <AddIcon />
            {getTitle()}
          </Button>
        );
      }
    } catch (error) {
      return <></>;
    }
  };
  return (
    <div>
      {getIcon()}
      <Dialog open={open} fullWidth>
        <DialogTitle> {getTitle()}</DialogTitle>
        <DialogContent>
          <AppcodeForm editData={editData} onComplete={() => handleClose()} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
